<template>
  <nuxt-link v-slot="scopeSlots" v-bind="$attrs" :to="toPath" active-class="pointer-events-none">
    <slot :is-active="scopeSlots?.isActive"></slot>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { LocaleLinkProps } from '@/types/component'

const { locale } = useI18n()
const localePath = useLocalePath()

const props = defineProps<LocaleLinkProps>()

const toPath = computed(() => (props.to ? localePath(props.to, locale.value) : undefined))
</script>
